import { HttpClient } from '@angular/common/http'
import { inject, Injectable } from '@angular/core'
import { catchError, EMPTY, map } from 'rxjs'

import { TicketInfoState } from '@states/ticket-info'

const S3_BASE_URL = 'https://d1ewdy0bjst1f0.cloudfront.net'

@Injectable({
	providedIn: 'root',
})
export class HeaderImageService {
	readonly #http = inject(HttpClient)
	readonly #ticketInfoState = inject(TicketInfoState)

	getImage(operatorUuidOverride?: string, locationUuidOverride?: string) {
		const ticketInfo = this.#ticketInfoState.ticketInfo()
		const operatorUuid = operatorUuidOverride ?? ticketInfo?.company?.uuid
		const locationUuid = locationUuidOverride ?? ticketInfo?.location?.uuid

		if (!operatorUuid) return EMPTY

		const operatorUrl = `${S3_BASE_URL}/${operatorUuid}/image.webp`

		if (!locationUuid) {
			return this.#http.head(operatorUrl).pipe(
				map(() => operatorUrl),
				catchError(() => EMPTY)
			)
		}

		const locationUrl = `${S3_BASE_URL}/${operatorUuid}/${locationUuid}/image.webp`

		return this.#http.head(locationUrl).pipe(
			map(() => locationUrl),
			catchError(() =>
				this.#http.head(operatorUrl).pipe(
					map(() => operatorUrl),
					catchError(() => EMPTY)
				)
			)
		)
	}
}
